import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20cozy%20winter%20scene%20with%20soft%20golden%20amber%20light%20glowing%20through%20frosted%20window%2C%20artistic%20abstract%20warmth%20concept%2C%20gentle%20gradient%20from%20warm%20cream%20to%20deep%20amber%2C%20minimalist%20elegant%20atmosphere%2C%20soft%20bokeh%20effect%2C%20warm%20toned%20artistic%20photography%2C%20peaceful%20winter%20comfort%20aesthetic&width=1920&height=900&seq=hero-bg-rejiujiu&orientation=landscape"
          alt="热久久持久保暖 - 温暖冬日"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-[800px] mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/20 mb-6">
            <i className="ri-fire-line text-primary-400"></i>
            <span className="text-sm text-background-50 font-medium whitespace-nowrap">持久恒温 · 久热不散</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 leading-tight font-heading">
            让温暖<span className="text-primary-400">持久相伴</span>
          </h1>
          <p className="text-base md:text-lg text-background-50/80 mb-8 max-w-[600px] mx-auto leading-relaxed">
            热久久凭借先进发热技术与持久恒温性能，为户外作业、冬季出行和日常取暖提供全方位保暖解决方案
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/categories"
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap"
            >
              探索产品系列
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/about"
              className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 hover:bg-background-50/25 backdrop-blur-sm text-background-50 rounded-lg text-sm font-medium transition-all duration-200 border border-background-50/30 whitespace-nowrap"
            >
              了解热久久
            </Link>
          </div>

          <div className="mt-12 grid grid-cols-3 gap-6 max-w-[500px] mx-auto">
            {[
              { value: '500万+', label: '服务用户' },
              { value: '98.6%', label: '好评率' },
              { value: '12年', label: '行业经验' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">{stat.value}</div>
                <div className="text-xs md:text-sm text-background-50/60 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}